<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <span v-text="`${$lang.create} ${$lang.role} `" />
          </div>
          <LoadingSpinner :loading="loading" :text="$lang.sending_data" />

          <b-form v-show="!loading">
            <b-form-group
              :label="$lang.parent_role"
              label-for="parent_role_name"
              :label-cols="$config.form.labelCol"
            >
              <b-form-input
                id="parent_role_name"
                type="text"
                autocomplete="off"
                v-model="parent_role_name"
                :disabled="true"
              />
            </b-form-group>
            <b-form-group
              :label="$lang.caption"
              label-for="caption"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.caption"
                :rules="$v.caption.$params"
              />
              <b-form-input
                id="caption"
                type="text"
                autocomplete="off"
                :state="$v.caption.$dirty ? !$v.caption.$error : null"
                v-model="$v.caption.$model"
              />
              <b-form-invalid-feedback id="caption-feedback"
                >{{ $lang.error_required | replace($lang.caption) }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-alert show variant="primary">
              <mdicon name="information" size="20" class="mr-1" />
              <strong v-text="$lang.referenceRoleCodeAlert" />
            </b-alert>
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.reference_role_code}: `"
                :rules="$v.referenceRoleCode.$params"
              />
              <TreePage
                :usedInForm="true"
                :showAlertNotice="false"
                :showRoleSelected="true"
                limitSelected="1"
                :tags="referenceRoleCode"
                :generateRoleSelected="generateRoleSelectedOfTreePage"
                @updateRoleSelected="updatePreRoleSelected"
              />
              <b-form-invalid-feedback
                :state="
                  $v.referenceRoleCode.$dirty
                    ? !$v.referenceRoleCode.$error
                    : null
                "
              >
                <div v-if="!$v.referenceRoleCode.required">
                  {{
                    $lang.error_required | replace($lang.reference_role_code)
                  }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
            <div class="float-right">
              <b-button class="mx-1" variant="success" @click="submit">
                {{ $lang.submitButton }}
                <i class="fa fa-check" />
              </b-button>
              <b-button class="mx-1" variant="danger" @click="close">
                {{ $lang.cancelButton }}
                <i class="fa fa-ban" />
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TreePage from "@/components/tree/treePage";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "add-role",
  components: { TreePage, LoadingSpinner },
  validations: {
    caption: { required },
    referenceRoleCode: {},
  },
  props: {
    parent_role_name: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      caption: null,
      referenceRoleCode: [],
      generateRoleSelectedOfTreePage: false,
    };
  },
  methods: {
    pathOr,
    generateApiUrl,
    close() {
      this.$emit("close");
    },
    updatePreRoleSelected(data) {
      this.referenceRoleCode = data;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const reference_role_code = pathOr(
        null,
        ["0", "code"],
        this.referenceRoleCode
      );
      const payload = {
        caption: this.caption,
        reference_role_code,
        parent_code: this.parent_role_code,
        guard_name: this.$config.role_guard_name,
      };
      this.$emit("submit", payload);
    },
  },
};
</script>
